<template>
  <div>
    <div class="footer2 row">
      <div class="left col-contato">
        <div class="contato">
          <p>
            <span class="icone-whatsapp"
              ><i class="icofont-brand-whatsapp"></i></span
            >(83) 99841-4823 | (83) 98134-7977
          </p>
          <p v-if="$store.state.orcamento.empresa === 'esusfeedback'">
            contato@esusfeedback.com.br
          </p>
          <p v-else>contato@biatic.com.br</p>
          <div class="redes-sociais">
            <span v-if="$store.state.orcamento.empresa === 'esusfeedback'"
              ><span class="icone-instagram"
                ><i class="icofont-instagram"></i></span
              >esusfeedback</span
            >
            <span v-else
              ><span class="icone-instagram"
                ><i class="icofont-instagram"></i></span
              >biatic</span
            >
            <span
              ><span class="icone-youtube"
                ><i class="icofont-youtube-play"></i></span
              >/esusfeedback</span
            >
          </div>
        </div>
      </div>
      <div class="right col-endereco">
        <div
          v-if="$store.state.orcamento.empresa === 'esusfeedback'"
          class="endereco"
        >
          <p>CNPJ: 45.180.436/0001-48</p>
          <p>Rua Antônio Ferreira Ramalho, nº 43, Sala 101</p>
          <p>CEP: 58980-000, Ibiarinha, Ibiara-PB.</p>
        </div>
        <div v-else class="endereco">
          <p>CNPJ: 27.197.452/0001-61</p>
          <p>Rua Antônio Ferreira Ramalho, nº 43, Sala 102</p>
          <p>CEP: 58980-000, Ibiarinha, Ibiara-PB.</p>
        </div>
      </div>
    </div>
    <div id="proposta">
      <!-- init new page -->
      <div class="new-page">
        <div class="row flex-column">
          <b-button
            class="imprimir"
            type="button"
            variant="primary"
            @click="imprimir()"
            >Imprimir ou PDF</b-button
          >
          <img
            v-if="$store.state.orcamento.empresa === 'biatic'"
            src="@/assets/images/proposta/biatic.png"
            class="logo"
            alt="biatic"
          />
          <img
            v-else
            src="@/assets/images/proposta/esusfeedback.png"
            class="logo"
            alt="esusfeedback"
          />
        </div>

        <p
          v-if="$store.state.orcamento.empresa === 'biatic'"
          class="titulo-principal"
        >
          A Biatic executa prestação de serviço especializado em análise de
          dados em saúde e Monitoramento e Avaliação na Atenção Primária à Saúde
          (APS). Ações que contribuem para acompanhar a qualidade da assistência
          a população municipal e consequentemente atender aos requisitos do
          Cofinanciamento federal 2024 e a maximização de recursos federais para
          a APS.
        </p>
        <p v-else class="titulo-principal">
          A eSUS Feedback presta serviço especializado em Busca Ativa,
          Monitoramento e Avaliação na Atenção Primária à Saúde (APS). Essas
          ações contribuem diretamente para acompanhar a qualidade da
          assistência à população municipal, atender aos requisitos do
          Cofinanciamento Federal na APS (Portaria 3493) e maximizar os recursos
          federais destinados ao município.
        </p>
        <h1 class="titulo">1 APRESENTAÇÃO DE PROPOSTA COMERCIAL</h1>

        <p>
          Prezado(a) Gestor(a) Municipal de Saúde de
          <strong>{{ _nomeMunicipio }}</strong
          >, a gestão da saúde pública é desafiadora, tornando-se essencial
          adotar soluções inteligentes que otimizem a busca ativa, o
          monitoramento e a avaliação das ações e serviços ofertados nas
          Unidades Básicas de Saúde (UBS). A nossa proposta auxilia na
          conformidade com os requisitos do cofinanciamento federal da APS.
        </p>
        <p>
          Nesse contexto, apresentamos uma proposta inovadora e eficaz para
          Busca Ativa, Monitoramento e Avaliação na APS. Esta solução não apenas
          aprimorará a qualidade dos serviços prestados, mas também fornecerá
          dados valiosos para auxiliar na tomada de decisões estratégicas
          diárias pelos gestores e profissionais de saúde.
        </p>

        <p>
          O cofinanciamento federal da APS garante que o município não vai
          perder recursos, pelo menos no período de transição (maio de 2024 a
          abril de 2025). Após esse intervalo, o desempenho municipal vai
          interferir diretamente no valor mensal e anual que o município vai
          receber. A projeção é de que o município possa ganhar ou perder um
          valor de até
          <b>
            R$
            {{
              diferencaMensalOtimoRegular.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </b>
          no repasse mensal ou até
          <b>
            R$
            {{
              diferencaAnualOtimoRegular.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            }}
          </b>
          no repasse anual após o período de transição. Esse valor representa a
          diferença entre o desempenho <b>"ÓTIMO"</b> e o desempenho
          <b>"REGULAR"</b> que o município pode alcançar nos componentes de
          qualidade, vínculo e acompanhamento. A realização de M & A na APS
          torna-se indispensável para monitorar e avaliar e, assim, evitar a
          perda de recursos federais para a APS.
        </p>

        <p>
          Estamos confiantes de que esta proposta trará benefícios
          significativos para a gestão de saúde do município, elevando o padrão
          de atendimento e garantindo um uso mais eficiente dos recursos
          disponíveis na APS.
        </p>

        <h2 class="title-2 text-left">1.1 Desempenho do município</h2>

        <div class="content-text">
          <p>
            O desempenho municipal (qualidade, vínculo e acompanhamento) será
            avaliado de acordo com classificações qualitativas (<b
              >REGULAR, SUFICIENTE, BOM ou ÓTIMO</b
            >). Esta avaliação terá um impacto direto e significativo no valor
            total dos recursos recebidos mensalmente e anualmente no
            cofinanciamento federal da APS.
          </p>
          <p>
            Durante o período de transição (maio de 2024 até abril de 2025), o
            município de
            <b
              >{{ $store.state.orcamento.form.cidade }} -
              {{ $store.state.orcamento.form.estado }}</b
            >, está classificado como <b>"BOM"</b>. Pode ser que em maio de
            2025, na primeira classificação oficial, receba um <b>"REGULAR"</b>,
            se não iniciar desde já ações voltadas a atender os requisitos
            estabelecidos na Portaria nº 3493. A classificação
            <b>“REGULAR”</b> faria com que o município tivesse recursos federais
            reduzidos nos repasses mensais para a APS.
          </p>

          <p>
            <i
              >Para garantir que o município não venha a perder recursos,
              recomenda-se iniciar ações de M & A na APS de acordo com as
              recomendações do cofinanciamento federal da APS.</i
            >
          </p>
          <p>
            Considerando que, de acordo com o desempenho municipal (qualidade,
            vínculo e acompanhamento), a classificação muda, impactando no valor
            recebido em cada mês e no ano. Apresentam-se na sequência, os
            cenários para serem analisados.
          </p>
        </div>

        <h2 class="title-3 text-left">1.1.1 Regular</h2>

        <p>
          Se o desempenho municipal for classificado como <b>“REGULAR”</b>, o
          quadro 1 e o Gráfico 1 demonstram a simulação dos valores que serão
          repassados <b>mensalmente</b> por componente ao município. Este
          cenário representa o menor valor possível que o município pode receber
          no cofinanciamento da APS.
        </p>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <span style="text-transform: uppercase; font-weight: bold"
              >Quadro 1, Gráfico 1 – Valores e percentuais na hipótese de
              desempenho municipal “REGULAR”.</span
            >
          </div>
          <div class="col-lg-6">
            <tabela-descricao
              :fixo="fixo"
              :vinculoAcompanhamento="vinculo_e_acompanhamento[3].valorTotal"
              :qualidade="qualidade[3].valorTotal"
              :perCapita="perCapitaTotal"
              :fonte="_fonte"
            ></tabela-descricao>
          </div>
          <div class="col-lg-6">
            <!-- <span class="text-center d-block">Gráfico 1</span> -->
            <div class="grafico-tabela-revisao">
              <apexchart
                ref="chartPie"
                type="pie"
                width="360"
                :options="chartPieOptions"
                :series="chartPieSeriesRegular"
              ></apexchart>
            </div>
          </div>
        </div>

        <p>
          É importante lembrar que, se o recurso estiver suspenso, esse valor
          pode ser ainda menor. Portanto, realizar o monitoramento e avaliação
          mensalmente, vai ajudar a atender aos requisitos estabelecidos e
          também evitar as suspensões de recursos federais para a APS municipal.
        </p>

        <div class="mt-4">
          <h2 class="title-3 text-left">1.1.2 Suficiente</h2>

          <p>
            Na hipótese do desempenho municipal ser <b>“SUFICIENTE”</b>, o
            quadro 2 e o gráfico 2 apresentam simulação dos valores a serem
            repassados por componente <b>mensalmente (a cada mês)</b> ao
            município no cofinanciamento federal da APS.
          </p>

          <div class="row align-items-center">
            <div class="col-lg-12">
              <span style="text-transform: uppercase; font-weight: bold"
                >Quadro 2, Gráfico 2 – Valores e percentuais na hipótese de
                desempenho municipal "SUFICIENTE".</span
              >
            </div>
            <div class="col-lg-6">
              <tabela-descricao
                :fixo="fixo"
                :vinculoAcompanhamento="vinculo_e_acompanhamento[2].valorTotal"
                :qualidade="qualidade[2].valorTotal"
                :perCapita="perCapitaTotal"
                :fonte="_fonte"
                numeroQuadro="6"
                classificacao="Suficiente"
              ></tabela-descricao>
            </div>
            <div class="col-lg-6">
              <!-- <span class="text-center d-block">Gráfico 2</span> -->
              <div class="grafico-tabela-revisao">
                <apexchart
                  ref="chartPie"
                  type="pie"
                  width="360"
                  :options="chartPieOptions"
                  :series="chartPieSeriesSuficiente"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>

        <p>
          A classificação <b>“SUFICIENTE”</b>, também pode fazer o município
          perder recursos federais destinados à APS.
        </p>

        <h2 class="title-3 text-left">1.1.3 Bom</h2>

        <div class="content-text">
          <p>
            Na hipótese do desempenho municipal ser <b>“BOM”</b>, o quadro 3 e o
            gráfico 3 apresentam simulação dos valores a serem repassados por
            componente <b>mensalmente (a cada mês)</b> ao município no
            cofinanciamento federal da APS.
          </p>
        </div>

        <div class="row align-items-center">
          <div class="col-lg-12">
            <span style="text-transform: uppercase; font-weight: bold"
              >Quadro 3, Gráfico 3 – Valores e percentuais na hipótese de
              desempenho municipal "BOM".</span
            >
          </div>
          <div class="col-lg-6">
            <tabela-descricao
              :fixo="fixo"
              :vinculoAcompanhamento="vinculo_e_acompanhamento[1].valorTotal"
              :qualidade="qualidade[1].valorTotal"
              :perCapita="perCapitaTotal"
              :fonte="_fonte"
              numeroQuadro="7"
              classificacao="Bom"
            ></tabela-descricao>
          </div>
          <div class="col-lg-6">
            <!-- <span class="text-center d-block">Gráfico 3</span> -->
            <div class="grafico-tabela-revisao">
              <apexchart
                ref="chartPie"
                type="pie"
                width="360"
                :options="chartPieOptions"
                :series="chartPieSeriesSuficiente"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div>
          <div class="content-text">
            <p>
              A classificação <b>“BOM”</b>, é bom para o município, pois será
              considerada automaticamente no período de maio de 2024 a abril de
              2025 (período de transição) e o município, provavelmente, não
              perde recursos federais na APS, mas ainda não é ótimo ter apenas a
              classificação <b>“BOM”</b>.
            </p>
            <p>
              Recomenda-se que as ações de gestores e profissionais de saúde da
              APS no território estejam alinhadas pelo objetivo de conseguir a
              classificação <b>“ÓTIMO”</b> que representa o máximo de desempenho
              conforme o novo modelo de cofinanciamento federal da APS.
            </p>
          </div>
        </div>

        <h2 class="title-3 text-left">1.1.4 Ótimo</h2>

        <div class="content-text">
          <p>
            <i>
              Esse será o desempenho que todos, equipe gestora e profissionais
              de saúde (eSF, ACS, eAP, eSB e eMulti), devem perseguir como
              objetivo nos municípios.
            </i>
          </p>

          <p>
            O Quadro 4 e o Gráfico 4 apresentam simulação dos valores a serem
            repassados por
            <b>componente mensalmente (a cada mês)</b> ao município no
            cofinanciamento federal da APS, quando o desempenho for
            <b>“ÓTIMO”</b>.
          </p>

          <p>
            O objetivo do município é maximizar o recebimento dos recursos
            federais na Atenção Primária à Saúde (APS) e, com isso, garantir com
            qualidade a oferta das ações e serviços de saúde para a população em
            seu território.
          </p>
        </div>

        <div class="row align-items-center">
          <div class="col-lg-12">
            <span style="text-transform: uppercase; font-weight: bold"
              >Quadro 4, Gráfico 4 – Valores e percentuais na hipótese de
              desempenho municipal "ÓTIMO".</span
            >
          </div>
          <div class="col-lg-6">
            <tabela-descricao
              :fixo="fixo"
              :vinculoAcompanhamento="vinculo_e_acompanhamento[0].valorTotal"
              :qualidade="qualidade[0].valorTotal"
              :perCapita="perCapitaTotal"
              :fonte="_fonte"
              numeroQuadro="8"
              classificacao="Ótimo"
            ></tabela-descricao>
          </div>
          <div class="col-lg-6">
            <!-- <span class="text-center d-block">Gráfico 4</span> -->
            <div class="grafico-tabela-revisao">
              <apexchart
                ref="chartPie"
                type="pie"
                width="360"
                :options="chartPieOptions"
                :series="chartPieSeriesOtimo"
              ></apexchart>
            </div>
          </div>
        </div>

        <p>
          <i
            >"Não se gerencia o que não se mede, não se mede o que não se define
            e não se define o que não se entende, ou seja, não há sucesso no que
            não se monitora, avalia, intervém e gerencia"</i
          >, esta citação é, regularmente, atribuída ao estatístico William
          Edwards Deming e nos diz que é preciso conhecer, definir, monitorar,
          avaliar, enfim, gerenciar para ter sucesso.
        </p>

        <div class="content-text">
          <p>
            Complementando, CONASEMS (2024), ressalta a necessidade de realizar
            monitoramento e avaliação com a utilização de ferramentas de
            informática confiáveis como forma de melhorar a assistência à
            população e consequentemente atender aos requisitos estabelecidos no
            novo modelo de cofinanciamento federal da APS.
          </p>
          <p>
            Portanto, o uso do monitoramento e avaliação integrado ao processo
            de trabalho dos profissionais de saúde em equipe atuando de forma
            estratégica (eSF, ACS, eAP, eSB e eMulti) pode ajudar no objetivo de
            conseguir a classificação de desempenho
            <b>“ÓTIMO”</b> para as equipes e para o município.
          </p>
        </div>

        <h2 class="title-3 text-left">1.1.5 Análise dos cenários</h2>

        <div class="content-text">
          <p>
            O Quadro 5 contém de forma consolidada
            <b>mensalmente (a cada mês)</b> uma comparação dos valores recebidos
            no modelo anterior e no cofinanciamento federal da APS. Nele,
            recomenda-se observar, especialmente se conforme o desempenho, o
            município tem aumento ou redução de repasses federais na APS.
            Valores negativos (com sinal de menos -) representam diminuição do
            valor em relação ao modelo de financiamento anterior.
          </p>

          <p v-html="textoTabelaPorcentagem"></p>
        </div>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <p>
          Portanto, para não perder recursos federais na APS, que pode acontecer
          se o desempenho for
          <b style="color: red">“REGULAR”</b> ou
          <b style="color: red">“SUFICIENTE”</b>, faz-se necessário trabalhar
          para um desempenho <b style="color: green">“ÓTIMO”</b> em cada equipe
          e consequentemente a nível municipal.
        </p>

        <tabela-porcentagem
          numeroQuadro="5"
          :data="dadosTabelaPorcentagem"
          :fonte="_fonte"
        ></tabela-porcentagem>

        <p v-html="texto2TabelaPorcentagem"></p>

        <div class="mt-4">
          <span style="text-transform: uppercase; font-weight: bold"
            >Gráfico 5 - Total mensal de recursos do cofinanciamento federal da
            APS por classificação
          </span>
          <div id="chart">
            <apexchart
              class="chartBar"
              ref="chartPorcentagem"
              type="bar"
              height="350"
              :options="chartBarOptions"
              :series="chartSeriesTabelaPorcentagem"
            ></apexchart>
          </div>
          <span class="fonte d-block mb-3" v-html="_fonte"></span>
        </div>

        <p v-html="texto3TabelaPorcentagem"></p>

        <div class="mt-4">
          <span style="text-transform: uppercase; font-weight: bold"
            >Gráfico 6 - Total anual de recursos do cofinanciamento federal da
            APS por classificação
          </span>
          <div id="chart">
            <apexchart
              class="chartBar"
              ref="chartPorcentagemAnual"
              type="bar"
              height="350"
              :options="chartBarOptions"
              :series="chartSeriesTabelaPorcentagemAnual"
            ></apexchart>
          </div>
          <span class="fonte d-block mb-3" v-html="_fonte"></span>
        </div>

        <p>
          Espera-se que essas informações sobre os 4 (quatro) possíveis cenários
          de desempenho e seu impacto nos repasses mensais e anuais de recursos
          federais para a APS de {{ _nomeMunicipio }}, possam ajudar no
          planejamento das ações.
        </p>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div
        v-if="this.$store.state.orcamento.pec_online === true"
        class="new-page"
      >
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <div class="pec-online">
          <h1 class="titulo">e-SUS PEC ONLINE</h1>
          <p>
            Colocar seu e-SUS PEC na nuvem para ser acessado via internet,
            estando disponivel 24 horas por dia, 7 dias por semana. Os
            benefícios são:
          </p>
          <ol class="lista-numerica" style="margin-left: 60px">
            <li>
              O backup é feito diariamente, automaticamente e disponibilizado
              para a Secretaria Municipal de Saúde. Com isso o município garante
              a segurança das informações e mantem os dados sempre em posse da
              gestão municipal;
            </li>
            <li>
              Envio de dados para o SISAB automático conforme processo de
              agendamento do e-SUS PEC. Como o servidor fica ligado 24 horas por
              dia, 7 dias por semana, então não corre o risco dos dados não
              serem processados;
            </li>
            <li>
              Atualização da última versão do e-SUS PEC em tempo oportuno para
              que o município e as equipes não percam as melhorias que estão
              sempre sendo lançadas;
            </li>
            <li>
              O acesso acontece por meio de link personalizado com o nome do
              município,
              <a :href="linkCidadeEstado" target="_blank">{{
                linkCidadeEstado
              }}</a
              >;
            </li>
            <li>
              A instalação dos e-SUS PEC em servidor online leva em consideração
              os requisitos mínimos do sistema disponibilizados pelo Ministério
              da Saúde;
            </li>
            <li>
              Os ACS que usam o e-SUS Território podem sincronizar seus dados de
              qualquer lugar que tenha internet e podem fazer isso todo dia.
              Assim, não correrá o risco de perder dados por passar uma semana
              sem sincronizar ou ter que sempre ir a um lugar fixo para realizar
              a sincronização. Essa ação contribui para a melhoria da Capitação
              Ponderada;
            </li>
            <li>
              Os demais aplicativos (e-SUS Atividade Coletiva, e-SUS AD, e-SUS
              Vacinação e Gestão e-SUS APS) podem ser sincronizados de qualquer
              lugar com acesso a internet. Isso facilita o trabalho e diminui as
              perdas de informação em virtude da dificuldade ou impossibilidade
              de sincronização dos dados desses aplicativos com o servidor e-SUS
              PEC;
            </li>
            <li>
              O Registro tardio de informações pode ser realizado de qualquer
              computador com acesso a internet. Isso aumenta a possibilidade
              para não perder registros de informações, uma vez que os
              profissionais da equipe não ficam dependentes apenas dos
              computadores de seu ambiente de trabalho para a digitação desses
              atendimentos. Isso contribui para melhorar os resultados do
              indicadores do Cofinanciamento federal 2024;
            </li>
            <li>
              Base de dados unificada, ou seja, um único cadastro por paciente e
              um único prontuário por paciente permite o cuidado continuado ao
              paciente e sua família, uma vez que ao comparecer a diversas UBS
              dentro do município, o cidadão ou cidadã não terá um cadastro e um
              prontuário em cada UBS, mas sim um Prontuário Eletrônico do
              Cidadão (PEC), onde todos os profissionais da APS poderam
              acompanhar o que foi realizado anteriormente e dar continuidade no
              cuidado ao cidadão ou cidadã. Isso acaba com o problema, por
              exemplo do médico da equipe A ao atender um cidadão não poder
              visualizar o seu histórico, pois os registros estão na equipe B;
            </li>
            <li>
              O PEC unificado também facilita diante da necessidade de entregar
              os registros impressos para os pacientes;
            </li>
            <li>
              É a garantia da unificação dos cadastros do cidadão ou cidadã, uma
              vez que a recomendação atual é registrar com o CPF e os
              profissionais não precisarão ficar atualizando um cadastro por
              UBS, mas sim o cadastro municipal;
            </li>
            <li>
              Colocar o e-SUS PEC online é sair da lógica de sistema da equipe
              para sistema do município, onde todas as equipes o acessam e fazem
              o cuidado continuado de todos os cidadãos e cidadãs assistidos no
              município
            </li>
          </ol>
          <p>
            Em suma, e-SUS PEC Online pode ser acessado de qualquer computador
            com acesso a internet, manter a segurança dos dados com backups em
            nuvem, unificar as bases de dados do e-SUS PEC que o município tem,
            manter o envio de dados sempre em dias, contribuir para a economia
            do município, uma vez que reduz custos com manutenção de servidores
            físicos (energia elétrica, refrigeração, recursos humanos para
            manutenção e software), melhorar os resultados do Cofinanciamento
            federal 2024, dentre outros.
          </p>
        </div>
      </div>
      <!-- end new page  -->

      <!-- init new page -->
      <div
        v-if="this.$store.state.orcamento.treinamento.ativo === true"
        class="new-page"
      >
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <div class="pec-online">
          <h1 class="titulo">
            TREINAMENTO e-SUS PEC/CDS {{ treinamentoUpper }}
          </h1>
          <p>
            O e-SUS Atenção Primária (e-SUS APS) tem o objetivo de reestruturar
            as informações da Atenção Primária de todo o Brasil. Sendo a
            qualificação da gestão da informação fundamental para ampliar a
            qualidade no atendimento à população, faz-se necessário realizar
            Educação Continuada e Educação Permanente para os profissionais de
            saúde visando qualificá-los para o correto Registro Clínico
            Eletrônico de dados em Saúde.
          </p>
          <p>O e-SUS APS está composto por diversos sistemas e aplicativos:</p>
          <ul style="margin-left: 45px">
            <li>• e-SUS PEC – Prontuário Eletrônico do Cidadão;</li>
            <li>• e-SUS Centralizador – Centralizador de Dados;</li>
            <li>
              • e-SUS PEC Centralizador – Prontuário Eletrônico do Cidadão e
              Centralizador;
            </li>
            <li>• e-SUS CDS – Sistema de Coleta Simplificada de Dados;</li>
            <li>• Aplicativo e-SUS APS Atividade Coletiva;</li>
            <li>• Aplicativo e-SUS APS Território;</li>
            <li>• Aplicativo e-SUS AD;</li>
            <li>• Aplicativo e-SUS Vacinação;</li>
            <li>• Aplicativo Gestão e-SUS APS.</li>
          </ul>

          <p>
            O treinamento é prático e individualizado, com os profissionais de
            saúde acessando o ambiente de treinamento e executando as
            atividades, enquanto o especialista os instrui sobre o correto uso
            das funcionalidades dos diversos recursos disponíveis.
          </p>
          <p>
            Como o e-SUS APS está organizado em perfis, de acordo a atuação de
            cada profissional de saúde na APS, o treinamento também se organiza
            dessa forma para utilizando-se de vídeoconferência e momentos
            presenciais (a depender da estratégia escolhida pelo gestor
            municipal de saúde.
          </p>
          <p>
            A capacitação envolve qualificar os profissionais que atuam na
            gestão e na assistênia à saúde, logo o treinamento está dividido da
            seguinte forma:
          </p>
          <ul style="margin-left: 45px">
            <li>
              • Treinamento e suporte no aplicativo e-SUS Atividade Coletiva
              para ações de Educação em Saúde, Programa Saúde na Escola,
              Academia de Saúde e outros;
            </li>
            <li>
              • Treinamento e suporte no perfil ACS no aplicativo e-SUS
              Território ou similar bem como CDS para a qualificação dos dados
              no Cadastro Domiciliar e Territorial, Cadastro Individial
              (Capitação Ponderada) e Visita Domiciliar;
            </li>
            <li>• Treinamento e suporte na Administração do e-SUS PEC;</li>
            <li>
              • Treinamento e suporte perfis gestores (Secretário, Gerente de
              UBS e de APS) para analisar dados dos relatórios e-SUS PEC e
              aplicativo Gestão e-SUS APS;
            </li>
            <li>
              • Treinamento e suporte perfil sala de vacina (e-SUS PEC, CDS e
              Aplicativo e-SUS Vacinação);
            </li>
            <li>• Treinamento e suporte perfil médico;</li>
            <li>• Treinamento e suporte perfil odontólogo;</li>
            <li>• Treinamento e suporte perfil recepção;</li>
            <li>
              • Treinamento e suporte perfil técnico de enfermagem e saúde
              bucal;
            </li>
            <li>• Treinamento e suporte perfil enfermeiro;</li>
            <li>
              • Suporte Qualificação dos cadastros na APS por eliminação das
              inconsistências;
            </li>
            <li>
              • Suporte Unificação de prontuários duplicados no e-SUS AB PEC;
            </li>
          </ul>

          <p>
            As ações de Educação Permanente em Saúde na correta utilização da
            estratégia e-SUS APS leva em consideração todas as orientações do
            Ministério da Saúde para a qualificação dos dados, no que diz
            respeito aos requisitos do Programa Cofinanciamento federal 2024.
          </p>
        </div>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <h1 class="titulo">2 ESUS FEEDBACK</h1>
        <p>
          O eSUS Feedback
          <a
            href="https://esusfeedback.com.br/"
            target="_blank"
            class="proposta-link"
            >www.esusfeedback.com.br</a
          >
          é um app que atende as necessidades de modernização na Busca Ativa,
          Monitoramento e Avaliação na APS, inclusive para acompanhar a
          Capitação Ponderada, Ações Estratégicas, Pagamentos por Desempenho e
          outros programas estratégicos, os quais fazem parte do Cofinanciamento
          federal 2024.
        </p>

        <h1 class="titulo" style="font-style: italic; font-weight: normal">
          O eSUS Feedback apresenta as seguintes funcionalidades e requisitos:
        </h1>
        <ol class="lista-ol">
          <li>
            Pode ser executado e/ou acessado em smartphones com Android, Iphone
            ou computadores com navegador atualizado e acesso à internet;
          </li>
          <li>
            Os profissionais de saúde e gestores podem consultar e visualizar
            cidadãos e seus atendimentos, desde que eles estejam sob seus
            cuidados;
          </li>
          <li>
            Permite o monitoramento dos cadastros individuais por Agente
            Comunitário de Saúde;
          </li>
          <li>
            Possibilita o acompanhamento das pessoas visitadas por Agente
            Comunitário de Saúde;
          </li>
          <li>
            Tem capacidade para o monitoramento e avaliação dos resultados dos
            indicadores de desempenho da APS estratificado por município, equipe
            e microárea;
          </li>
          <li>
            Viabiliza o acompanhamento dos atendimentos no âmbito do programa
            Informatiza APS;
          </li>
          <li>
            Auxilia gestores e profissionais de saúde no monitoramento e
            avaliação das ações de saúde no território;
          </li>
          <li>
            Disponibiliza painel de gestão que pode ser acessado pelas
            principais tecnologias (computador, smartphone/iphone) utilizando o
            sistema operacional Linux, Windows, MAC OS, IOS ou Android com
            navegador de internet atualizado;
          </li>
          <li>
            Permite a identificação dos cadastros duplicados de cidadãos dentro
            do e-SUS PEC ou Centralizador;
          </li>
          <li>
            Mostra os cidadãos não vinculados às equipes de APS dentro do e-SUS
            PEC ou Centralizador;
          </li>
          <li>
            Lista os cidadãos não vinculados aos Agentes Comunitários de Saúde
            dentro do e-SUS PEC ou Centralizador;
          </li>
          <li>
            Identifica os cidadãos com possível CNS inválido ou com falta de CPF
            no Cadastro Individual (Ficha completa e Ficha reduzida);
          </li>
          <li>
            Monitora o envio de dados pelo registro das Visitas Domiciliares dos
            Agentes Comunitários de Saúde para o sistema e-SUS PEC ou
            Centralizador;
          </li>
          <li>
            Cruza os dados dos profissionais de saúde cadastrados no e-SUS PEC
            ou Centralizador e SCNES para que os dados dos atendimentos na APS
            sejam validados e enviados com sucesso para o sistema SISAB do
            Ministério da Saúde;
          </li>
          <li>
            Identifica os cidadãos com menos de 2 anos que estão com vacinas
            atrasadas;
          </li>
          <li>
            Permite aos gestores e profissionais de saúde acompanharem os
            atendimentos realizados na APS por data e turno nos últimos 90 dias;
          </li>
          <li>
            Tem capacidade para mediar a busca ativa em relação aos diversos
            tipos de serviços disponíveis na APS facilitando a comunicação entre
            gestores e profissionais de saúde das equipes;
          </li>
          <li>
            Possibilidade a comunicação de dados e informações entre os gestores
            e os profissionais das equipes de saúde, entre os profissionais da
            própria equipe, inclusive os Agentes Comunitários de Saúde;
          </li>
          <li>
            Integra-se com o sistema e-SUS PEC ou Centralizador para a
            importação dos dados já cadastrados, os quais são necessários à
            geração da informação que é disponibilizada;
          </li>
          <li>
            Tem ajuda audiovisual por perfil cadastrado explicando sobre a
            interpretação dos dados que estão em exibição, bem como a resolução
            de problemas dentro do e-SUS PEC ou Centralizador;
          </li>
          <li>
            Permite buscas personalizadas para encontrar informações relevantes
            à tomada de decisão;
          </li>
          <li>
            Pode ser utilizado em qualquer cenário de informatização da APS que
            o município esteja fazendo uso, inclusive consegue ler dados
            enviados a partir de sistemas próprios ou sistemas de terceiros.
          </li>
        </ol>
      </div>
      <!-- end new page  -->

      <!-- init new page -->
      <div class="new-page">
        <h1 class="titulo">2.1 SISAB e PEC</h1>
        <p>
          O Sistema de Informação da Atenção Básica (SISAB), apresenta
          resultados tardios em relação às ações em desenvolvimento no
          município, ou seja, quando não é mais possível, em muitos casos,
          realizar medidas para evitar as perdas de recursos. Cumpre ainda
          destacar que o SISAB, em razão da quantidade de acessos, fica, por
          muitas vezes, indisponível em horário comercial.
        </p>

        <p>
          O Prontuário Eletrônico do Cidadão, e-SUS PEC ou Centralizador não
          traz resposta em tempo oportuno para as principais perguntas dos
          gestores e profissionais de saúde a respeito do vínculo,
          acompanhamento e o componente de qualidade, bem como visitas
          domiciliares e outras ações que são requisitos do cofinanciamento
          federal da APS.
        </p>

        <p>
          São muitas perguntas a serem respondidas diariamente com o objetivo de
          apresentar resumos e resultados quantitativos e qualitativos que podem
          ajudar profissionais de saúde e gestores municipais na tomada de
          decisão.
        </p>

        <h1 class="titulo">2.2 Teste o eSUS Feedback</h1>

        <p>
          <strong>
            Nós, que trabalhamos com análise de dados em saúde, estamos
            oferecendo a você a oportunidade de testar o app eSUS Feedback,
            juntamente com ou sem uma assessoria especializada em Tecnologia da
            Informação e Comunicação em Saúde como estratégia para maximizar o
            recebimento de recursos federais para a APS municipal no
            Cofinanciamento federal 2024.</strong
          >
        </p>

        <p>
          Você pode receber uma demonstração e testar o eSUS Feedback por 30
          dias sem custo para a gestão municipal.
        </p>
      </div>
      <!-- end new page -->

      <!-- init new page -->
      <div class="new-page">
        <div class="imagem-header">
          <img
            v-if="$store.state.orcamento.empresa === 'biatic'"
            src="@/assets/images/biatic-colorido.png"
            class="logo"
            alt="biatic"
          />
          <img
            v-else
            src="@/assets/images/logo.png"
            class="logo"
            alt="esusfeedback"
          />
        </div>
        <!-- MONITORAMENTO E AVALIAÇÃO NA APS -->
        <div v-if="$store.state.orcamento.mea_na_aps === true">
          <h1 class="titulo">MONITORAMENTO E AVALIAÇÃO NA APS</h1>
          <p>
            O Programa Cofinanciamento federal 2024 estabeleceu regras,
            normativas e requisitos, a serem atendidos, os quais são necessários
            para os municípios receberem 100% dos repasses federais na APS. Para
            atender a esses requisitos, faz-se necessário Monitorar e Avaliar a
            situação da oferta das Ações e Serviços de Saúde, bem como os
            resultados atuais. De acordo com William Edwards Deming, que é
            considerado o pai da gestão da qualidade,
            <i
              >“Não se gerencia o que não se mede, não se mede o que não se
              define e não se define o que não se entende, ou seja,
              <strong
                >não há sucesso no que não se monitora, avalia, intervém e
                gerencia</strong
              >”</i
            >.
          </p>
          <p>
            O Monitoramento e Avaliação na Atenção Primária à Saúde
            <strong>(M & A na APS)</strong> historicamente sempre foi difícil de
            ser praticado por falta de informações sempre atualizadas e
            disponíveis no momento da sua necessidade. Também faltavam metas
            claras e transparentes que expressassem os desafios a serem vencidos
            para alcançar os objetivos. Outras dificuldades eram estabelecer
            indicadores com parâmetros que permitissem identificar, mensurar,
            acompanhar e comunicar, de forma simples, a evolução de determinado
            aspecto da intervenção proposta nas metas com apuração periódica e
            possibilidade de avaliação e intervenção.
          </p>
          <p>
            A maioria dos supramencionados desafios foram vencidos e viraram
            requisitos a serem atendidos no Programa Cofinanciamento federal
            2024, mas os municípios ainda não conseguem realizar
            <strong>M & A na APS</strong> de forma integrada ao processo de
            trabalho dos profissionais das equipes de saúde da APS municipal. A
            proposta de <strong>M & A na APS</strong> consistem em:
          </p>

          <ol style="list-style: auto; margin-left: 60px">
            <li>
              Realizar treinamento inicial sobre M & A na APS por equipe para os
              profissionais de saúde;
            </li>
            <li>
              Entregar informação em tempo oportuno para as equipes de saúde,
              individualmente, e ofertar feedback sobre as principais dúvidas no
              processo de qualificação dos dados no que diz respeito ao registro
              clínico em Prontuário Eletrônico do Cidadão;
            </li>
            <li>
              Reunir-se regularmente (uma vez por mês) com cada equipe de saúde
              municipal para discutir os principais problemas da qualificação da
              informação e outros pertinentes ao processo de trabalho;
            </li>
            <li>
              Reunir-se regularmente (a critério da gestão) com os gestores
              municipais para prestar esclarecimentos sobre dúvidas envolvendo
              os resultados atuais com base nos indicadores e metas
              estabelecidos;
            </li>
            <li>
              Realizar regulamente (uma vez por mês) por equipe um processo de
              interpretação dos dados para identificar oportunidade de busca
              ativa e solucionar os problemas que os profissionais por si só
              ainda não conseguiram resolver;
            </li>
            <li>
              Atender eletronicamente (WhatsApp, telefone ou videoconferência) a
              chamados que precisam de apoio técnico na solução de problemas
              envolvendo a qualificação de dados em saúde.
            </li>
          </ol>

          <p>
            A realização de <strong>M & A na APS</strong> integrado ao processo
            de trabalho das equipes (Medicina, Enfermagem, Odontologia,
            Recepcionistas, Vacinadores, Agentes Comunitários de Saúde e outros)
            tem-se mostrado eficiente nas experiências praticadas, pois
            personaliza e individualiza o apoio técnico de acordo com as
            necessidades dos profissionais e diante dos problemas que eles
            apresentam. Com esse processo, permite-se sair da teoria e dos
            momentos expositivos dialogados (que tem caráter mais informacional)
            para treinamento prático e mais imersivo (que tem mais capacidade de
            gerar aprendizagem).
          </p>
        </div>
        <!-- plano de trabalho -->
        <div
          v-else-if="$store.state.orcamento.primeiraContratacao === 'primeira'"
        >
          <h1 class="titulo">3 PLANO DE TRABALHO</h1>
          <p>
            Após a decisão municipal de utilização do app eSUS Feedback, que
            acontece pela criação do perfil de Secretário(a) Municipal de Saúde
            na página inicial da plataforma
            <a
              href="https://esusfeedback.com.br/login"
              target="_blank"
              class="proposta-link"
              >https://esusfeedback.com.br/login</a
            >, a gestão municipal pode usar o eSUS Feedback por 30 (trinta)
            dias, um período de avaliação. A partir dos 20 (vinte) dias da data
            de implantação do período de teste e apresentação, entramos em
            contato com representantes da gestão municipal para dar andamento a
            uma possível parceria.
          </p>
          <p>
            Caso o município tenha interesse em continuar utilizando a
            plataforma, então assina-se o contrato entre as partes e iniciam-se
            os treinamentos. Se o município não desejar continuar utilizando o
            eSUS Feedback, então todos os dados relacionados ao município são
            deletados no servidor do eSUS Feedback.
          </p>
          <p>Em suma, essa proposta inclui:</p>
          <p>
            1. Antes da assinatura do contrato e sob responsabilidade da
            contratada:
          </p>
          <ul class="lista-sem-marcacao-2">
            <li>
              a. Instalação do eSUS Feedback para ser acessado por todos ou
              alguns profissionais de saúde e gestores da Atenção Primária à
              Saúde;
            </li>
            <li>
              b. Período de avaliação de 30 dias, sem custo, para testar as
              funcionalidades da ferramenta;
            </li>
            <li>
              c. Apresentação do eSUS Feedback no período de avaliação para
              profissionais de nível superior, gestão, coordenação e Tecnologia
              da Informação (TI) do município;
            </li>
          </ul>

          <p>
            2. Após a assinatura do contrato e sob solicitação expressa da
            contratante:
          </p>
          <ul class="lista-sem-marcacao-2">
            <li>
              a. Treinamento no Cofinanciamento federal 2024 por equipe de saúde
              do município (Enfermagem, Medicina Odontologia, Recepcionistas,
              ACS e gestores municipais);
            </li>
            <li>
              b. 30 dias depois do treinamento inicial, acompanhamento para
              tirar dúvidas dos profissionais por equipe;
            </li>
            <li>
              c. Quadrimestralmente, reunião por equipe para comunicar os
              resultados do quadrimestre e trabalhar o eSUS Feedback para as
              buscas ativas;
            </li>
            <li>
              d. Suporte contínuo (WhatsApp, chat online e Videoconferência pelo
              google meet) agendadas previamente.
            </li>
          </ul>
        </div>
        <div
          v-else-if="$store.state.orcamento.primeiraContratacao === 'renovacao'"
        >
          <h1 class="titulo">3 PLANO DE TRABALHO</h1>
          <p>
            Após a decisão municipal de continuar utilizando o app eSUS
            Feedback, assina-se o contrato entre as partes e continua-se o
            suporte e treinamento, quando solicitados. Se o município não
            desejar continuar utilizando o eSUS Feedback, então todos os dados
            relacionados são deletados no servidor do eSUS Feedback.
          </p>
          <p>Está incluso no suporte:</p>
          <ul class="lista-sem-marcacao-2" style="margin-left: 52px !important">
            <li>
              • Quadrimestralmente, reunião por equipe** ou com a gestão
              municipal para comunicar os resultados do quadrimestre e trabalhar
              o eSUS Feedback para as buscas ativas e o monitoramento e
              avaliação na APS;
            </li>
            <li>
              • Suporte contínuo (WhatsApp, chat online e Videoconferência pelo
              google meet) agendadas previamente.
            </li>
          </ul>
        </div>
        <!-- Fim plano de trabalho -->
      </div>
      <!-- end new page  -->

      <!-- init new page  -->
      <div class="new-page">
        <div class="row flex-column">
          <div class="imagem-header">
            <img
              v-if="$store.state.orcamento.empresa === 'biatic'"
              src="@/assets/images/biatic-colorido.png"
              class="logo"
              alt="biatic"
            />
            <img
              v-else
              src="@/assets/images/logo.png"
              class="logo"
              alt="esusfeedback"
            />
          </div>
        </div>
        <h1 class="titulo">4 PROPOSTA DE PREÇO DOS SERVIÇOS</h1>
        <p>
          Esta proposta leva em consideração que o município de
          <span class="variaveis">
            {{ $store.state.orcamento.cidade }} –
            {{ $store.state.orcamento.estado }}</span
          >
          possui
          <span class="variaveis"
            >{{ $store.state.orcamento.total_equipe }} ({{
              numero_extenso
            }})</span
          >
          equipes de saúde entre eSF e eAP e pretende contratar os serviços
          descritos na tabela abaixo por período de
          {{ $store.state.orcamento.quantidade_meses }} meses com início em data
          a ser combinada entre as partes.
        </p>
        <table class="tabela">
          <thead>
            <tr>
              <th>SERVIÇOS</th>
              <th>*PARCELAS</th>
              <th>**EQUIPES</th>
              <th>V. POR EQUIPE</th>
              <th>VALOR MENSAL</th>
              <th>VALOR TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>eSUS Feedback</td>
              <td
                v-if="this.$store.state.orcamento.parcelaImplantacao === true"
              >
                {{ parcelaImplantacao }} +
                {{ $store.state.orcamento.quantidade_meses }}
              </td>
              <td v-else>{{ $store.state.orcamento.quantidade_meses }}</td>

              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span
                ><span>{{ valorEquipePorFaixaEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualEsusFeedback }}</span>
              </td>
            </tr>
            <tr v-if="$store.state.orcamento.mea_na_aps === true">
              <td>M & A na APS</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span
                ><span>{{ valorEquipePorFaixaEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalEsusFeedback }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualEsusFeedback }}</span>
              </td>
            </tr>
            <tr v-else>
              <td>Plano de trabalho</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td><span>R$</span><span>00,00</span></td>
              <td><span>R$</span><span>00,00</span></td>
              <td><span>R$</span><span>00,00</span></td>
            </tr>
            <tr v-if="this.$store.state.orcamento.pec_online === true">
              <td>e-SUS Pec online</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorEquipeVezesFaixaPecOnline }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorMensalPecOnline }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorAnualPecOnline }}</span>
              </td>
            </tr>
            <tr v-if="this.$store.state.orcamento.treinamento.ativo === true">
              <td>
                EPS e-SUS PEC/CDS
                {{ this.$store.state.orcamento.treinamento.tipo }}
              </td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoPorEquipe }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoMensal }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTreinamentoAnual }}</span>
              </td>
            </tr>
            <tr>
              <td>Total do contrato</td>
              <td>
                {{
                  parseInt($store.state.orcamento.quantidade_meses) +
                  parcelaImplantacao
                }}
              </td>
              <td>{{ $store.state.orcamento.total_equipe }}</td>
              <td>
                <span>R$</span><span>{{ valorTotalPorEquipe }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTotalMensal }}</span>
              </td>
              <td>
                <span>R$</span><span>{{ valorTotalAnual }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          * A 1ª parcela é faturada com a implantação do(s) serviço(s). Ela visa
          cobrir custos que se tem para iniciar a oferta do(s) serviço(s). As
          demais parcelas referem-se a licença para uso dos serviços propostos.
        </p>
        <p>
          ** Até 6 equipes por município, o plano de trabalho, suporte e apoio
          no uso do eSUS Feedback pode ser realizado direto com os profissionais
          de saúde das equipes, um técnico responsável pelos ACS e equipe
          gestora. A partir de 7 equipes por município, o plano de trabalho,
          suporte e apoio no uso do eSUS Feedback é realizado para a equipe
          gestora municipal que multiplica, ou seja, conduz com os
          profissionais.
        </p>
        <p style="margin-top: 0px; margin-bottom: 20px">
          Essa proposta de prestação de serviço tem validade de 60 dias a contar
          da data deste documento.
        </p>
        <p>Ibiara – PB, {{ _dataQueOUsuarioEscolheu }}.</p>

        <p class="atenciosamente" style="margin-top: 10px; margin-bottom: 20px">
          Atenciosamente,
        </p>
        <p v-if="$store.state.orcamento.empresa === 'biatic'">
          <span class="texto-negrito"
            >BIATIC ASSESSORIA EM TECNOLOGIA DA INFORMAÇÃO E COMUNICAÇÃO EM
            SAÚDE</span
          >, sociedade empresárial, com sede na Rua João Ciriaco, 251,
          Ibiarinha, Ibiara-PB, CEP nº 58.980-000, inscrita no CNPJ/MF sob nº
          27.197.452/0001-61.
        </p>
        <p v-else>
          <span class="texto-negrito"
            >ESUS FEEDBACK CONSULTORIA E SERVICOS LTDA</span
          >, sociedade empresarial, com sede na Rua Antônio Ferreira Ramalho, nº
          43, Sala 101, Ibiarinha, Ibiara - PB, CEP nº 58980-000, inscrita no
          CNPJ/MF sob nº 45.180.436/0001-48.
        </p>
        <div class="footer">
          <span v-if="$store.state.orcamento.empresa === 'biatic'"
            >E-mail
            <a href="mailto:contato@biatic.com.br" class="proposta-link"
              >contato@biatic.com.br</a
            ></span
          >
          <span v-else
            >E-mail
            <a href="mailto:contato@esusfeedback.com.br" class="proposta-link"
              >contato@esusfeedback.com.br</a
            ></span
          >

          <span
            >Instagram
            <a
              href="https://www.instagram.com/biatic"
              target="_blank"
              class="proposta-link"
              >https://www.instagram.com/biatic</a
            ></span
          >
          <span
            >YouTube
            <a
              href="https://www.youtube.com/c/esusfeedback"
              target="_blank"
              class="proposta-link"
              >https://www.youtube.com/c/esusfeedback</a
            ></span
          >
          <span
            >Contato/Whatsapp
            <a
              href="http://api.whatsapp.com/send?1=pt_BR&phone=5583998414823"
              class="proposta-link"
              >83 99841-4823</a
            >
            /
            <a
              href="http://api.whatsapp.com/send?1=pt_BR&phone=5583981347977"
              target="_blank"
              class="proposta-link"
              >9 98134-7977</a
            ></span
          >
        </div>
        <div class="topo">
          <b-button type="button" variant="primary" @click="topo()"
            ><i class="icofont-arrow-up"></i>Topo</b-button
          >
        </div>
      </div>
      <!-- end new page  -->
    </div>
  </div>
</template>

<script>
import TabelaDescricao from '@/pages/CofinanciamentoSimulacao/components/TabelaDescricao.vue'
import TabelaPorcentagem from '@/pages/CofinanciamentoSimulacao/components/TabelaPorcentagem.vue'
import { regras } from '@/pages/CofinanciamentoSimulacao/utils.js'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'Proposta',
  components: {
    TabelaDescricao,
    apexchart: VueApexCharts,
    TabelaPorcentagem,
  },
  data() {
    return {
      numero_extenso: '',
      capitacao_ponderada: 0,
      fixo: {
        implantacao: '',
        custeio: '',
        valorImplantacao: 0,
        valorCusteio: 0,
      },
      vinculo_e_acompanhamento: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      qualidade: [
        {
          classificacao: 'Ótimo',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Bom',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Suficiente',
          text: '',
          valorTotal: 0,
        },
        {
          classificacao: 'Regular',
          text: '',
          valorTotal: 0,
        },
      ],
      previne_brasil: {
        capitacaoPonderada: 0,
        pagamentoDesempenho: 0,
        informatizaAps: 0,
        indicadoresSaudeBucal: 0,
        indicadoresSaudeNaHora: 0,
        pagamentoCriterioPopulacional: 0,
      },
      perCapita: 0,
      perCapitaTotal: 0,
      dadosTabelaPorcentagem: [],
      showModal: false,
      loadingBtnSalvarSugestao: false,
      form: {
        sugestao: '',
      },
      chartPieSeriesRegular: [],
      chartPieSeriesSuficiente: [],
      chartPieSeriesBom: [],
      chartPieSeriesOtimo: [],
      chartPieOptions: {
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: [
          'Fixo Implantação',
          'Fixo de custeio',
          'Qualidade',
          'Vínculo e acompanhamento',
          'Per capita',
        ],
        colors: ['#156082', '#E97132', '#196B24', '#0F9ED5', '#A02B93'],
        legend: {
          position: 'bottom',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 350,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      chartSeriesTabelaPorcentagem: [],
      chartSeriesTabelaPorcentagemAnual: [],
      chartBarOptions: {
        xaxis: {
          categories: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return (
                'R$ ' +
                val.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              )
            },
          },
        },
        colors: ['#22B14C', '#FFF200', '#FF7F27', '#ED1C24'],
        plotOptions: {
          bar: {
            columnWidth: '65%',
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              'R$ ' +
              val.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })
            )
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ['#304758'],
          },
        },
        legend: {
          show: false,
        },
      },
      regras: regras,
      textoTabelaPorcentagem: '',
      texto2TabelaPorcentagem: '',
      texto3TabelaPorcentagem: '',
      showSidebarMenu: false,
      diferencaMensalOtimoRegular: 0,
      diferencaAnualOtimoRegular: 0,
    }
  },
  mounted() {
    const writtenNumber = require('written-number')
    writtenNumber.defaults.lang = 'pt'
    this.numero_extenso = writtenNumber(
      this.$store.state.orcamento.total_equipe
    )

    this.preencherRelatorio()
  },
  computed: {
    _nomeMunicipio() {
      return (
        this.$store.state.orcamento.cidade +
        ' – ' +
        this.$store.state.orcamento.estado
      )
    },
    _fonte() {
      let dataAtual = new Date()

      let nomesMeses = [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ]

      let mesAtual = nomesMeses[dataAtual.getMonth()]

      let anoAtual = dataAtual.getFullYear()

      let mesAnoFormatado = mesAtual + '/' + anoAtual
      return `<b>Fonte</b>: Autoria própria, ${mesAnoFormatado}`
    },
    _dataQueOUsuarioEscolheu() {
      const dia = this.$store.state.orcamento.data_inicio.split('/')[0]
      const mes = this.$store.state.orcamento.data_inicio.split('/')[1]

      let mesExtenso = ''
      switch (mes) {
        case '01':
          mesExtenso = 'janeiro'
          break
        case '02':
          mesExtenso = 'fevereiro'
          break
        case '03':
          mesExtenso = 'março'
          break
        case '04':
          mesExtenso = 'abril'
          break
        case '05':
          mesExtenso = 'maio'
          break
        case '06':
          mesExtenso = 'junho'
          break
        case '07':
          mesExtenso = 'julho'
          break
        case '08':
          mesExtenso = 'agosto'
          break
        case '09':
          mesExtenso = 'setembro'
          break
        case '10':
          mesExtenso = 'outubro'
          break
        case '11':
          mesExtenso = 'novembro'
          break
        case '12':
          mesExtenso = 'dezembro'
          break
      }

      const ano = this.$store.state.orcamento.data_inicio.split('/')[2]
      return `${dia} de ${mesExtenso} de ${ano}`
    },
    parcelaImplantacao() {
      if (this.$store.state.orcamento.parcelaImplantacao === true) {
        return 1
      }
      return 0
    },
    treinamentoUpper() {
      return this.$store.state.orcamento.treinamento.tipo.toUpperCase()
    },
    linkCidadeEstado() {
      this.$store.state.orcamento

      return `${this.$store.state.orcamento.cidade.toLowerCase()}${this.$store.state.orcamento.estado.toLowerCase()}.com.br`
    },
    /* ------------------ Valores eSUS Feedback ------------------ */
    valorEquipePorFaixaEsusFeedback() {
      let valor = this.$store.state.orcamento.faixa_preco

      if (this.$store.state.orcamento.acrescimo === true) {
        valor = valor + valor * 0.06
      }
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    valorMensalEsusFeedback() {
      let faixa_preco = this.$store.state.orcamento.faixa_preco
      if (this.$store.state.orcamento.acrescimo === true) {
        faixa_preco = faixa_preco + faixa_preco * 0.06
      }
      const valor = this.$store.state.orcamento.total_equipe * faixa_preco
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    valorAnualEsusFeedback() {
      let faixa_preco = this.$store.state.orcamento.faixa_preco
      if (this.$store.state.orcamento.acrescimo === true) {
        faixa_preco = faixa_preco + faixa_preco * 0.06
      }
      const valorMes = this.$store.state.orcamento.total_equipe * faixa_preco
      const valorAno =
        valorMes *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valorAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /* ------------------ Valores e-SUS Pec Online ------------------ */
    valorEquipeVezesFaixaPecOnline() {
      const valor =
        this.$store.state.orcamento.faixa_preco_pec_online /
        this.$store.state.orcamento.total_equipe
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    valorMensalPecOnline() {
      const valor = this.$store.state.orcamento.faixa_preco_pec_online
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },

    valorAnualPecOnline() {
      const valorMes = this.$store.state.orcamento.faixa_preco_pec_online
      const valorAno =
        valorMes *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valorAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /* ------------------ Valores treinamento ------------------  */
    // Online 500 Reais
    // Presencial 1200 Reais
    valorTreinamentoPorEquipe() {
      if (
        this.$store.state.orcamento.treinamento.tipo.toLowerCase() === 'online'
      ) {
        let valor = 500.0
        return valor
          .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })
          .replace('R$', '')
      }
      if (
        this.$store.state.orcamento.treinamento.tipo.toLowerCase() ===
        'presencial'
      ) {
        let valor = 1200.0
        return valor
          .toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })
          .replace('R$', '')
      }
      return ''
    },
    valorTreinamentoMensal() {
      let valor =
        this.computedEmNumero(this.valorTreinamentoPorEquipe) *
        this.$store.state.orcamento.total_equipe
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    valorTreinamentoAnual() {
      let valor =
        this.computedEmNumero(this.valorTreinamentoMensal) *
        (this.$store.state.orcamento.quantidade_meses + this.parcelaImplantacao)
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /* ------------------ Valores totais ------------------ */
    /* ------------------ Valores Por Equipe ------------------ */
    valorTotalPorEquipe() {
      /* Apenas esus feedback */
      let valor = null
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valor = this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorEquipeVezesFaixaPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoPorEquipe)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valor =
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback) +
          this.computedEmNumero(this.valorEquipeVezesFaixaPecOnline) +
          this.computedEmNumero(this.valorTreinamentoPorEquipe)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        valor =
          valor + this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      return valor
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /* ------------------ Valores Mensal ------------------ */
    valorTotalMensal() {
      let valorTotal = null
      /* Apenas esus feedback */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        const valorFeddback =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        valorTotal = valorFeddback + 0
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorMensalPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoMensal)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valorTotal =
          this.computedEmNumero(this.valorMensalEsusFeedback) +
          this.computedEmNumero(this.valorMensalPecOnline) +
          this.computedEmNumero(this.valorTreinamentoMensal)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        valorTotal =
          valorTotal +
          this.$store.state.orcamento.total_equipe *
            this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
      }
      return valorTotal
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /* ------------------ Valores Anual ------------------ */

    /* Apenas esus feedback */
    valorTotalAnual() {
      let valoTotalAno = null

      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        const valorMesFeedback =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        const valorAnoFeedback =
          valorMesFeedback *
          (this.$store.state.orcamento.quantidade_meses +
            this.parcelaImplantacao)
        valoTotalAno = valorAnoFeedback + 0
      }
      /* Com esus feedback + pec online */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === false
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorAnualPecOnline)
      }
      /* Com esus feedback + treinamento */
      if (
        this.$store.state.orcamento.pec_online === false &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorTreinamentoAnual)
      }
      /* Com esus feedback + pec online + treinamento */
      if (
        this.$store.state.orcamento.pec_online === true &&
        this.$store.state.orcamento.treinamento.ativo === true
      ) {
        valoTotalAno =
          this.computedEmNumero(this.valorAnualEsusFeedback) +
          this.computedEmNumero(this.valorAnualPecOnline) +
          this.computedEmNumero(this.valorTreinamentoAnual)
      }
      if (this.$store.state.orcamento.mea_na_aps === true) {
        const valorMes =
          this.$store.state.orcamento.total_equipe *
          this.computedEmNumero(this.valorEquipePorFaixaEsusFeedback)
        const valorAno =
          valorMes *
          (this.$store.state.orcamento.quantidade_meses +
            this.parcelaImplantacao)
        valoTotalAno = valoTotalAno + valorAno
      }
      return valoTotalAno
        .toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
    },
    /*  ----------------------------------------------------------------------- */

    dia() {
      const date = new Date()
      const diaHoje = date.getDate()
      let diaString = diaHoje.toString()
      let dia = ''
      if (diaString.length < 2) {
        dia = diaString = `0${diaString}`
      } else {
        dia = diaString
      }
      return dia
    },
    mes() {
      const date = new Date()
      const diaMes = date.getMonth() + 1
      let mesExtenso = ''
      switch (diaMes) {
        case 1:
          mesExtenso = 'janeiro'
          break
        case 2:
          mesExtenso = 'fevereiro'
          break
        case 3:
          mesExtenso = 'março'
          break
        case 4:
          mesExtenso = 'abril'
          break
        case 5:
          mesExtenso = 'maio'
          break
        case 6:
          mesExtenso = 'junho'
          break
        case 7:
          mesExtenso = 'julho'
          break
        case 8:
          mesExtenso = 'agosto'
          break
        case 9:
          mesExtenso = 'setembro'
          break
        case 10:
          mesExtenso = 'outubro'
          break
        case 11:
          mesExtenso = 'novembro'
          break
        case 12:
          mesExtenso = 'dezembro'
          break
      }
      return mesExtenso
    },
    ano() {
      const date = new Date()
      return date.getFullYear()
    },
  },
  methods: {
    preencherRelatorio() {
      const novasEquipes =
        this.$store.state.orcamento.form.dadosSimulacao.equipes_novas.equipes
      // componente fixo por implantação
      if (novasEquipes != null) {
        let somaComponenteFixoImplantacao = novasEquipes.reduce((acc, item) => {
          return acc + item.valor_implantacao * parseInt(item.value)
        }, 0)

        const quantEsf = novasEquipes.find((el) => el.key == 'esf')?.value
        const quantEAP30h = novasEquipes.find(
          (el) => el.key == 'eap_30h'
        )?.value
        const quantEAP20h = novasEquipes.find(
          (el) => el.key == 'eap_20h'
        )?.value
        const quantESB40h = novasEquipes.find(
          (el) => el.key == 'esb_40h'
        )?.value
        const quantEmultiAmpliada = novasEquipes.find(
          (el) => el.key == 'emulti_ampliada'
        )?.value
        const quantEmultiComplementar = novasEquipes.find(
          (el) => el.key == 'emulti_complementar'
        )?.value
        const quantEmultiEstrategica = novasEquipes.find(
          (el) => el.key == 'emulti_estrategica'
        )?.value
        this.fixo.implantacao = `
          Passa a receber <b>R$ ${somaComponenteFixoImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo implantação em parcela única. Esse valor considera: <b>${quantEsf} eSF</b>, <b>${quantEAP30h} eAP 30h</b>, <b>${quantEAP20h} eAP 20h</b>, <b>${quantESB40h} eSB 40h</b>, <b>${quantEmultiAmpliada} eMulti ampliada</b>, <b>${quantEmultiComplementar} eMulti complementar</b> e <b>${quantEmultiEstrategica} eMulti estratégica</b> novas que foram implantadas.
        `
        this.fixo.valorImplantacao = somaComponenteFixoImplantacao
      } else {
        this.fixo.implantacao =
          'O município não tem equipes novas a serem consideradas no componente fixo de implantação.'
      }

      const equipesImplantadas =
        this.$store.state.orcamento.form.dadosSimulacao.equipes_implantadas

      if (equipesImplantadas != null) {
        // componente fixo por custeio
        const ied = this.$store.state.orcamento.form.dadosSimulacao.ied.value
        const valoresDasEquipesCusteio = this.regras.fixo.custeio.find(
          (item) => item.ied === ied
        )
        let somaComponenteCusteioImplantacao = 0
        valoresDasEquipesCusteio.tipos_equipes.forEach((element) => {
          let quantidadeDeEquipes = equipesImplantadas[element.label]
          somaComponenteCusteioImplantacao +=
            element.valor * quantidadeDeEquipes
        })

        this.fixo.custeio = `
          Passa a receber <b>R$ ${somaComponenteCusteioImplantacao.toLocaleString(
            'pt-BR',
            {
              minimumFractionDigits: 2,
            }
          )}</b> no componente fixo de custeio. Esse valor considera: <b>${
          equipesImplantadas['eSF 40h']
        } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b>, <b>${
          equipesImplantadas['eAP 20h']
        } eAP 20h</b>.
        `
        this.fixo.valorCusteio = somaComponenteCusteioImplantacao

        // componente de vínculo e acompanhamento
        for (
          let index = 0;
          index < this.vinculo_e_acompanhamento.length;
          index++
        ) {
          const element = this.vinculo_e_acompanhamento[index]
          let val = this.valoresComponenteVinculoAcompanhamento(
            equipesImplantadas,
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }

        // Componente de qualidade
        for (let index = 0; index < this.qualidade.length; index++) {
          const element = this.qualidade[index]
          let val = this.valoresComponenteQualidade(
            equipesImplantadas,
            element.classificacao
          )
          element.text = val.text
          element.valorTotal = val.total
        }
      }

      //capitação ponderada
      this.capitacao_ponderada =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.capitacaoPonderada.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // pagamento por desempenho
      this.previne_brasil.pagamentoDesempenho =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoDesempenho.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // indicadores saúde bucal
      this.previne_brasil.indicadoresSaudeBucal =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.indicadoresSaudeBucal.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // informatiza aps
      this.previne_brasil.informatizaAps =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.informatizaAps.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )

      // pagamento critério populacional
      this.previne_brasil.pagamentoCriterioPopulacional =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      // per capita
      this.perCapita =
        this.previne_brasil.pagamentoCriterioPopulacional.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )
      this.perCapitaTotal =
        this.$store.state.orcamento.form.dadosSimulacao.previne_brasil.pagamentoCriterioPopulacional

      // Dados gráfico Regular
      this.chartPieSeriesRegular = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[3].valorTotal,
        this.vinculo_e_acompanhamento[3].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Suficiente
      this.chartPieSeriesSuficiente = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[2].valorTotal,
        this.vinculo_e_acompanhamento[2].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Bom
      this.chartPieSeriesBom = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[1].valorTotal,
        this.vinculo_e_acompanhamento[1].valorTotal,
        this.perCapitaTotal,
      ]

      // Dados gráfico Ótimo
      this.chartPieSeriesOtimo = [
        this.fixo.valorImplantacao,
        this.fixo.valorCusteio,
        this.qualidade[0].valorTotal,
        this.vinculo_e_acompanhamento[0].valorTotal,
        this.perCapitaTotal,
      ]

      this.formatarDadosDaTabelaPorcentagem()
    },

    valoresComponenteVinculoAcompanhamento(equipesImplantadas, classificacao) {
      let somaComponenteVinculoAcompanhamento = 0
      for (let label in equipesImplantadas) {
        const resultado = this.regras.vinculo_e_acompanhamento.find(
          (item) => item.label === label
        )
        if (resultado) {
          const classificacaoEquipe = resultado.classificacao.find(
            (el) => el.tipo === classificacao
          )
          let quantidadeDeEquipes = equipesImplantadas[label]
          somaComponenteVinculoAcompanhamento +=
            classificacaoEquipe.valor * quantidadeDeEquipes
        }
      }
      let text = `
        Passa a receber <b>R$ ${somaComponenteVinculoAcompanhamento.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )}</b> de vinculo e
              acompanhamento pela classificação ${classificacao.toUpperCase()} na transição entre maio
              de 2024 e maio de 2025. Após isso, o município pode melhorar sua
              classificação e aumentar mais esse valor. Esse valor considera: <b>${
                equipesImplantadas['eSF 40h']
              } eSF</b>, <b>${equipesImplantadas['eAP 30h']} eAP 30h</b> e <b>${
        equipesImplantadas['eAP 20h']
      } eAP 20h</b> novas que foram implantadas.`
      return {
        text: text,
        total: somaComponenteVinculoAcompanhamento,
      }
    },

    valoresComponenteQualidade(equipesImplantadas, classificacao) {
      let somaComponenteQualidade = 0
      for (let label in equipesImplantadas) {
        const resultado = this.regras.qualidade.find(
          (item) => item.label === label
        )
        if (resultado) {
          const classificacaoEquipe = resultado.classificacao.find(
            (el) => el.tipo === classificacao
          )
          let quantidadeDeEquipes = equipesImplantadas[label]
          somaComponenteQualidade +=
            classificacaoEquipe.valor * quantidadeDeEquipes
        }
      }
      let text = `
            Passa a receber <b>R$ ${somaComponenteQualidade.toLocaleString(
              'pt-BR',
              {
                minimumFractionDigits: 2,
              }
            )}</b> de qualidade pela classificação “BOM” na transição entre maio
                  de 2024 e maio de 2025. Após isso, o município pode melhorar sua
                  classificação e aumentar mais esse valor. Esse valor considera: <b>${
                    equipesImplantadas['eSF 40h']
                  } eSF 40h</b>, <b>${
        equipesImplantadas['eAP 30h']
      } eAP 30h</b>, <b>${equipesImplantadas['eAP 20h']} eAP 20h</b>, <b>${
        equipesImplantadas['eMulti Ampliada']
      } eMulti ampliada</b>,
      <b>${equipesImplantadas['eMulti Complementar']} eMulti complementar</b>,
      <b>${equipesImplantadas['eMulti Estratégica']} eMulti estratégica</b>,
                  <b>${equipesImplantadas['eSB I - Comum']} eSB I - Comum</b>,
                  <b>${equipesImplantadas['eSB II - Comum']} eSB II - Comum</b>,
                  <b>${
                    equipesImplantadas['eSB I- Quil/Assent']
                  } eSB I- Quil/Assent</b>,
                  <b>${
                    equipesImplantadas['eSB II- Quil/Assent']
                  } eSB II- Quil/Assent</b>
                  novas que foram implantadas.
            `
      return {
        text: text,
        total: somaComponenteQualidade,
      }
    },

    formatarDadosDaTabelaPorcentagem() {
      let dataClassificacao = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
      let data = []
      for (let index = 0; index < dataClassificacao.length; index++) {
        // classificação
        const classificacao = dataClassificacao[index]
        // vinculo e acompanhamento
        let vinculoAcompanhamento = 0
        let valorVinculoAcompanhamento = this.vinculo_e_acompanhamento.find(
          (item) => item.classificacao === classificacao
        )
        if (valorVinculoAcompanhamento) {
          vinculoAcompanhamento = valorVinculoAcompanhamento.valorTotal
        }
        // qualidade
        let qualidade = 0
        let valorQualidade = this.qualidade.find(
          (item) => item.classificacao === classificacao
        )
        if (valorQualidade) {
          qualidade = valorQualidade.valorTotal
        }
        // recebia
        let recebia = 0
        for (const key in this.$store.state.orcamento.form.dadosSimulacao
          .previne_brasil) {
          const element =
            this.$store.state.orcamento.form.dadosSimulacao.previne_brasil[key]
          recebia += element
        }
        // passa a receber
        const passaAreceber =
          this.fixo.valorImplantacao +
          this.fixo.valorCusteio +
          vinculoAcompanhamento +
          qualidade +
          this.perCapitaTotal
        // aumentou
        let aumentou = passaAreceber - recebia
        // percentual
        const result = (aumentou / recebia) * 100
        const aumentouPercentual = result.toFixed(2)

        data.push({
          recebia: recebia,
          desempenho: classificacao,
          passaAreceber: passaAreceber,
          aumentou: passaAreceber - recebia,
          aumentouPercentual: aumentouPercentual,
        })
      }

      const otimo = data.find((el) => el.desempenho === 'Ótimo')
      const bom = data.find((el) => el.desempenho === 'Bom')
      const suficiente = data.find((el) => el.desempenho === 'Suficiente')
      const regular = data.find((el) => el.desempenho === 'Regular')
      const diferenca = otimo.passaAreceber - regular.passaAreceber
      this.diferencaMensalOtimoRegular = diferenca

      this.textoTabelaPorcentagem = `
        No cenário de pior desempenho, <b style="color: red">“REGULAR”</b>, o município recebe o valor
            de <b style="color: red">R$
            ${regular.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>
            e no cenário de melhor desempenho, <b style="color: green">“ÓTIMO”</b>, o município recebe o
            valor de <b style="color: green">R$
            ${otimo.passaAreceber.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b>. A diferença de <b style="color: ${
        diferenca < 0 ? 'red' : 'green'
      }"> R$
            ${diferenca.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
            })}</b> está
            relacionada aos componentes de vínculo e acompanhamento e qualidade
            que são os valores variáveis do cofinanciamento federal na APS.

      `
      this.texto2TabelaPorcentagem = `
        No Gráfico 5, pode-se observar que o valor de R$ ${diferenca.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por mês</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.dadosTabelaPorcentagem = data

      this.$refs.chartPorcentagem.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber,
            bom.passaAreceber,
            suficiente.passaAreceber,
            regular.passaAreceber,
          ],
        },
      ])

      const diferencaAnualEntreOtimoRegular =
        otimo.passaAreceber * 12 - regular.passaAreceber * 12
      this.diferencaAnualOtimoRegular = diferencaAnualEntreOtimoRegular
      this.texto3TabelaPorcentagem = `
        No Gráfico 6, pode-se observar que o valor de R$ ${diferencaAnualEntreOtimoRegular.toLocaleString(
          'pt-BR',
          {
            minimumFractionDigits: 2,
          }
        )} representa o quanto o município <b>pode perder por ano</b> entre a classificação <b style='color: green'>“ÓTIMO”</b> e a classificação <b style='color: red'>“REGULAR”</b>.
      `

      this.$refs.chartPorcentagemAnual.updateSeries([
        {
          name: 'Desempenho',
          data: [
            otimo.passaAreceber * 12,
            bom.passaAreceber * 12,
            suficiente.passaAreceber * 12,
            regular.passaAreceber * 12,
          ],
        },
      ])
    },
    computedEmNumero(valor) {
      // Tira os pontos e substitui a virgula por ponto
      let formata = valor.replaceAll('.', '').replaceAll(',', '.')
      let paraFloat = parseFloat(formata)
      return paraFloat
    },

    imprimir() {
      document.title = this.$store.state.orcamento.empresa
      window.print()
    },
    topo() {
      window.scrollTo(0, 0)
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style type="text/css" scoped>
html {
  scroll-behavior: smooth;
}

.new-page {
  position: relative;
  page-break-before: always;
  page-break-inside: avoid;
}

* {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
}

#proposta {
  margin: 0 auto;
  width: 1200px;
}

@media screen and (max-width: 656px) {
  #proposta {
    margin: 0 15px;
    width: 100%;
  }
}

#proposta .logo {
  align-self: center;
  width: 140px;
  margin: 25px 0px;
}

#proposta .titulo {
  font-size: 25px;
  margin: 50px 0px 30px;
  font-weight: bold;
  text-align: justify;
}

#proposta .title-2 {
  font-size: 20px;
  margin: 30px 0px;
  font-weight: bold;
  text-align: justify;
  text-transform: unset;
}

#proposta .title-3 {
  font-size: 20px;
  margin: 30px 0px;
  font-weight: bold;
  text-align: justify;
}

#proposta .titulo-principal {
  margin: 20px 0px;
  font-size: 20px;
  text-align: center;
  font-weight: 100;
  color: #213669;
  line-height: initial;
}

#proposta p {
  margin: 15px 0;
  text-indent: 12mm;
}

#proposta .lista {
  list-style: disc;
  margin-left: 20px;
}

#proposta .variaveis {
  font-weight: bold;
  color: black;
}

#proposta .lista-numerica {
  list-style: decimal;
}

#proposta .texto-negrito {
  text-align: justify;
  color: black;
  font-weight: bold;
}

#proposta .proposta-link {
  color: #007bff;
  cursor: pointer;
}

#proposta .lista-ol {
  list-style: auto;
  margin-left: 60px;
}

#proposta .lista-sem-marcacao-2 {
  list-style: none;
  margin-left: 76px;
}

#proposta .tabela {
  width: 100%;
}

#proposta .tabela,
th,
td {
  margin-bottom: 16px;
  border: 1px solid black;
  color: black;
}

#proposta .tabela thead {
  color: black;
  text-align: center;
  background: #d9d9d9;
}

#proposta .tabela thead,
th {
  padding: 10px;
  border-bottom: 0px;
}

#proposta .tabela tbody td:nth-child(5),
td:nth-child(6) {
  font-weight: bold;
  color: black;
}

#proposta .tabela tbody td:nth-child(4) span:last-child,
td:nth-child(5) span:last-child,
td:nth-child(6) span:last-child {
  float: right;
  margin-right: 10px;
}

#proposta .tabela tbody,
td:nth-child(1),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6) {
  padding-left: 10px;
  text-align: left;
}

#proposta .tabela tbody,
td:nth-child(2),
td:nth-child(3) {
  text-align: center;
}

#proposta .footer {
  margin-bottom: 30px;
  display: contents;
  flex-direction: column;
  display: flex;
}
#proposta .btn {
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-size: 15px;
  padding: 0px 30px;
  text-transform: uppercase;
  font-weight: 700;
  box-shadow: inset 0 -2px 0 rgb(0 0 0 / 25%);
}

#proposta.btn:hover {
  background: #0fafd7;
  color: #0056b3;
}
#proposta .imprimir {
  position: absolute;
  right: 0px;
  top: 10px;
}
#proposta .topo {
  text-align: end;
  margin: 30px 0px;
}
#proposta {
  scroll-behavior: smooth;
}

@media screen {
  .footer2 {
    display: none;
  }
  .imagem-header {
    display: none;
  }
}

@media print {
  #proposta {
    position: relative;
    padding: 0;
    margin: 0;
    width: 100%;
    min-height: initial;
  }

  #proposta .col-lg-6 {
    width: 50%;
  }

  #proposta .new-page {
    margin: 0;
    padding: 0;
    width: 100%;
    page-break-before: always;
    page-break-inside: avoid;
  }

  #proposta .titulo-principal {
    text-align: center;
    font-size: 18pt;
    font-weight: 100;
    color: #213669;
  }

  #proposta .titulo {
    margin: 30px 0px;
  }

  #proposta .title-2,
  #proposta .title-3 {
    margin: 20px 0px;
  }

  #proposta p {
    font-size: 16pt;
  }

  #proposta .lista-numerica,
  #proposta ul,
  #proposta ol,
  #proposta .lista-ol {
    font-size: 16pt;
  }

  #proposta .tabela {
    font-size: 16px;
    width: 100%;
  }

  #proposta .footer {
    width: 100%;
    margin: 0px;
  }

  #proposta .footer span {
    margin: 0px;
  }

  #proposta .footer span a {
    margin: 0px;
  }

  #proposta .atenciosamente {
    margin-top: 200pt;
  }

  #proposta .imprimir {
    visibility: hidden;
  }

  #proposta .topo {
    visibility: hidden;
  }

  .footer2 {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 30mm;
    border-top: 2px solid #0b3161;
    background-color: #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20mm;
  }

  .footer2 .left,
  .footer2 .right {
    width: 49%;
  }

  .imagem-header {
    display: block;
    display: flex;
    justify-content: center;
    margin-bottom: 1px;
  }

  #proposta .logo {
    width: 150px;
  }

  .footer2 {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .footer2 .contato {
    -webkit-print-color-adjust: exact;
    background: #c3e8fa;
  }

  .footer2 p {
    color: #2246739b;
    margin-bottom: 0px;
  }

  .footer2 span {
    color: #2246739b;
  }

  .footer2 .endereco {
    display: flex;
    flex-direction: column;
    align-items: center;
    -webkit-print-color-adjust: exact;
    background: #c3e8fa;
  }

  .footer2 .imagem {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .footer2 .imagem .logo-footer {
    max-width: 70px;
  }

  .footer2 .contato {
    text-align: justify;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #c3e8fa;
  }

  .footer2 .contato .icone-whatsapp {
    display: inline-block;
    transform: rotate(272deg);
    margin-right: 5px;
  }

  .footer2 .contato .icone-instagram {
    margin-right: 5px;
  }

  .footer2 .contato .icone-youtube {
    margin-right: 5px;
  }

  .footer2 .contato .redes-sociais {
    display: flex;
    gap: 10px;
  }

  .titulo-principal {
    text-align: center !important;
  }
}
</style>
